import EventBus from '@/eventBus'
import store from '@/vuex/store'

export default {
  handleAIGenerateSlideEvent(doc) {
    store.dispatch('promptToSlideGenerator/handleGenerateSlideSocketSuccessAction', doc, { root: true })
  },
  handleAIGenerateSlideError() {
    store.dispatch('promptToSlideGenerator/handleGenerateSlideSocketErrorAction', { root: true })
  },
  handleAIGenerateTemplateDescription(doc) {
    EventBus.$emit('ai-template-description: generated', doc)
  },
  handleAIGenerateWordCloudSmartGrouping(doc) {
    EventBus.$emit('word-cloud-smart-grouping: generated', doc)
  },

  // DOC TO SLIDE
  handleDocToSlideGenerated(doc) {
    store.dispatch('docToSlideGenerator/handleDocToSlideSocketAction', doc, { root: true })
  },

  // DOC TO SLIDE GLOBAL IMPORT
  handleDocToSlideGenerationDoneWhenGlobalImport(doc) {
    store.dispatch('docToSlideGenerator/handleDocToSlideSocketGlobalImportAction', doc, { root: true })
  },
  handleDocToSlideImportConvertError(doc) {
    store.dispatch('docToSlideGenerator/handleDocToSlideSocketImportConvertErrorAction', doc, { root: true })
  },

  // OPEN ENDED SMART GROUPING
  handleAIGenerateOpenEndedSmartGrouping(doc) {
    EventBus.$emit('open-ended-smart-grouping: generated', doc)
  },
  handleAIOpenEndedSmartGroupingSubmissionChange(doc) {
    EventBus.$emit('open-ended-smart-grouping: submission_change', doc)
  },

  // INITIAL CONTENT
  handleChatResponse(socketData) {
    store.dispatch('promptToSlideGenerator/handleChatResponseSocketAction', socketData, { root: true })
  },
  handleUpdatePresentation(presentationId) {
    store.dispatch('dataActionGpt/handleUpdatePresentationToSocketAction', { presentationId }, { root: true })
  },
}
